<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import {
  GrammarFooter,
  GrammarModal,
  GrammarPrimaryButton,
  GrammarSecondaryButton,
  GrammarText,
} from '@nora-monorepo/grammar-ui';

import { useConfirmModalStore } from '#ui-shared/components/modals/confirm-modal/confirm-modal-store';

const emits = defineEmits(['confirm', 'cancel']);

const confirmModalStore = useConfirmModalStore();
const { closeModal, handleConfirm } = confirmModalStore;

const {
  isOpen,
  headerText,
  bodyText,
  confirmButtonLabel,
  cancelButtonLabel,
  confirmButtonType,
} = storeToRefs(confirmModalStore);

function onCancelClick() {
  closeModal();
  emits('cancel');
}

function onConfirmClick() {
  handleConfirm();
  emits('confirm');
}
</script>

<template>
  <GrammarModal
    :is-open="isOpen"
    :label="headerText"
    :show-close-button="true"
    @close="onCancelClick"
  >
    <template v-if="bodyText" #content>
      <GrammarText
        :text="bodyText"
        size="large"
        class="confirm-modal__body text-center"
      />
    </template>
    <template #footer>
      <GrammarFooter>
        <template #left-button>
          <GrammarSecondaryButton
            :label="cancelButtonLabel"
            @click="onCancelClick"
          />
        </template>
        <template #right-button>
          <GrammarPrimaryButton
            :label="confirmButtonLabel"
            :type="confirmButtonType"
            @click="onConfirmClick"
          />
        </template>
      </GrammarFooter>
    </template>
  </GrammarModal>
</template>

<style scoped>
.confirm-modal__body {
  max-width: calc(
    var(--sizingCustomModalsWidthMd)
    - var(--spacingCustomLayoutGridSidePaddingMd)
    - var(--spacingCustomLayoutGridSidePaddingMd)
  );
  overflow-wrap: anywhere;
}
</style>
